import { render, staticRenderFns } from "./QuickActions.vue?vue&type=template&id=98a443a8&scoped=true&"
import script from "./QuickActions.vue?vue&type=script&lang=js&"
export * from "./QuickActions.vue?vue&type=script&lang=js&"
import style0 from "./QuickActions.vue?vue&type=style&index=0&id=98a443a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98a443a8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
